import React from 'react';
import { Alert } from '@mui/material';

interface AdminErrorProps {
    message: string;
}

const AdminError: React.FC<AdminErrorProps> = ({ message }) => {
    return (
        <Alert severity="error" sx={{ mb: 3 }}>
            {message}
        </Alert>
    );
};

export default AdminError;